import React, { useState } from 'react'

import { DoubleLeftOutlined, DoubleRightOutlined } from '@ant-design/icons'
import { Checkbox, Spin } from 'antd'
import Button from 'components/Button'
import TableTransfer from './Transfer'
import {
  ButtonContainer,
  CenteredButtonsWrapper,
  StyledModal,
  BoldText,
  CancelButtonContainer,
  ExportButtonContainer,
} from './Style'
import styled from 'styled-components';

const StyledCheckbox = styled(Checkbox)`
  margin-left: 0 !important;
  margin-right: 8px;
  .ant-checkbox + span {
   font-weight: 600 !important; 
  }
`;

const ExportTransfer = ({
  open,
  columns,
  handleClose,
  data = [],
  handleExportType,
  handleExportClick,
  disabled = false,
  exportType,
  targetKeys = [],
  setTargetKeys,
  selectedKeys = [],
  setSelectedKeys,
  setExportLoading,
  exportLoading,
  hasEmailAndDownload=false,
  setIsEmailPopupVisible,
  setSelectedExportMethod,
  setSelectedExportType,
  selectedExportMethod,
  selectedExportType,
}) => {
  const [dataEnable, setDataEnable] = useState(false)

  const loadingTip = (selectedExportMethod === 'mail' && selectedExportType?.length === 1 && selectedExportType?.includes('cv_zip')) 
    ? "Counting Students..." 
    : "Exporting...";

  const onChange = nextTargetKeys => {
    const check = data.filter(item => nextTargetKeys?.includes(item.key))
    setSelectedKeys(check)
    setTargetKeys(nextTargetKeys)
  }

const handleExportMethodSelect = (method, type) => {
  if (selectedExportMethod && selectedExportMethod !== method) {
    setSelectedExportMethod(method);
    setSelectedExportType([type]);
    if (method !== 'mail') {
      handleExportType(type);
    } else {
      if (type !== 'cv_zip') {
        handleExportType(type);
      } else {
        handleExportType('');
      }
    }
    return;
  }

  if (method !== 'mail') {
    if (selectedExportMethod === method && selectedExportType.includes(type)) {
      setSelectedExportMethod('');
      setSelectedExportType([]);
      handleExportType('');
    } else {
      setSelectedExportMethod(method);
      setSelectedExportType([type]);
      handleExportType(type);
    }
    return;
  }

  setSelectedExportMethod('mail');
  
  setSelectedExportType(prev => {
    // If clicking the same type, toggle it off
    if (prev.includes(type)) {
      const newSelection = prev.filter(t => t !== type);
      // If we have any non-CV options left after toggling, call handleExportType with the last one
      const nonCvOptions = newSelection.filter(t => t !== 'cv_zip');
      if (nonCvOptions.length > 0) {
        handleExportType(nonCvOptions[0]);
      } else {
        handleExportType(''); 
      }
      return newSelection;
    }
    
    // If selecting CV ZIP
    if (type === 'cv_zip') {
      // If already selected, deselect it
      if (prev.includes('cv_zip')) {
        // If there are other options selected, keep them
        const newSelection = prev.filter(t => t !== 'cv_zip');
        // Call handleExportType with the first non-CV option if exists
        const nonCvOption = newSelection.find(t => t !== 'cv_zip');
        const newExportType = nonCvOption || '';
        if (newExportType !== exportType) {
          handleExportType(newExportType);
        }
        return newSelection;
      }
      // Otherwise, select CV ZIP and keep any other selected option
      const newSelection = [...prev.filter(t => t !== 'cv_zip'), 'cv_zip'];
      // Call handleExportType with the first non-CV option if exists
      const nonCvOption = newSelection.find(t => t !== 'cv_zip');
      const newExportType = nonCvOption || '';
      if (newExportType !== exportType) {
        handleExportType(newExportType);
      }
      return newSelection;
    }
    
    // If selecting a non-CV option
    const otherOptions = ['xlsx', 'googlesheet', 'csv'];
    const hasOtherOption = prev.some(t => otherOptions.includes(t));
    
    let newSelection;
    if (hasOtherOption) {
      // If another non-CV option is selected, replace it
      newSelection = [...prev.filter(t => !otherOptions.includes(t)), type];
    } else {
      // Otherwise, just add the new selection
      newSelection = [...prev, type];
    }
    
    // Call handleExportType with the selected non-CV option
    const nonCvOption = newSelection.find(t => t !== 'cv_zip');
    if ((nonCvOption || '') !== exportType) {
      handleExportType(nonCvOption || '');
    }
    
    return newSelection;
  });
};

// In your JSX, update the checkboxes like this:


  // const handleExportClickEmail = () => {
  //   if (selectedExportMethod === 'mail' && selectedExportType) {
  //     // Call the export function with the selected type
  //  setIsEmailPopupVisible(true)
  //   }
  //   else{
  //     handleExportClick()
  //   }
  // }
  const [selectedItems, setSelectedItems] = useState([])
  const handleMoveAllLeft = () => {
    setTargetKeys([])
    setSelectedKeys([])
  }

  const handleMoveAllRight = () => {
    setTargetKeys(data.map(item => item.key))
    setSelectedKeys(data)
  }
  const renderHeader = () => {
    const totalItems = data.length
    return `1/${totalItems}`
  }

  const mailOptions = [
    { name: 'cv_zip', key: 'CV ZIP file' },
    { name: 'xlsx', key: 'Excel' },
    { name: 'googlesheet', key: 'Google Sheet' },
    { name: 'csv', key: 'CSV' },
  ]

  const downloadOptions = [
    { name: 'xlsx', key: 'Excel' },
    { name: 'googlesheet', key: 'Google Sheet' },
    { name: 'csv', key: 'CSV' },
  ]

  const getformat = [
    { name: 'googlesheet', key: 'Google Sheet' },
    { name: 'csv', key: 'CSV' },
    { name: 'xlsx', key: 'XLSX' },
  ]
  return (
    <StyledModal open={open} hasEmailAndDownload={hasEmailAndDownload} centered>
      <Spin
        tip={loadingTip}
        size="large"
        spinning={exportLoading}
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <>
          <BoldText>
            Select the columns you want to display on your report
          </BoldText>
          <div style={{ display: 'flex', gap: '24px', alignItems: 'flex-start' }}>
            <div style={{ flex: 1 }}>
              <CenteredButtonsWrapper>
                <Button
                  onClick={handleMoveAllRight}
                  disabled={
                    targetKeys?.length === data?.length || selectedItems.length
                  }
                  style={{
                    position: 'absolute',
                    zIndex: 999,
                    transform: 'translate(521%, 152%)',
                    width: '63px',
                    height: '53px',
                    backgroundColor: 'white',
                    padding: '0px',
                  }}
                >
                  <DoubleRightOutlined
                    style={{ color: '#999FAC', fontSize: '22px' }}
                  />
                </Button>

                <TableTransfer
                  dataSource={data}
                  targetKeys={targetKeys}
                  disabled={disabled}
                  showSelectAll={false}
                  onChange={onChange}
                  pagination={false}
                  id="Modal"
                  getPopupContainer={() => document.getElementById('Modal')}
                  leftColumns={columns}
                  rightColumns={columns}
                  titles={[renderHeader(), renderHeader()]}
                  setDataEnable={setDataEnable}
                  dataEnable={dataEnable}
                  setSelectedItems={setSelectedItems}
                  selectedItems={selectedItems}
                />
                <Button
                  onClick={handleMoveAllLeft}
                  disabled={!targetKeys.length || selectedItems.length}
                  style={{
                    position: 'absolute',
                    zIndex: 999,
                    transform: 'translate(521%, -249%)',
                    width: '63px',
                    height: '53px',
                    backgroundColor: 'white',
                    padding: '0px',
                  }}
                >
                  <DoubleLeftOutlined
                    style={{ color: '#999FAC', fontSize: '22px' }}
                  />
                </Button>
              </CenteredButtonsWrapper>
            </div>

            {/* Right side export options */}
            {hasEmailAndDownload && (
              <div style={{ width: '300px', marginLeft: '24px' }}>
                <div style={{ 
                  marginBottom: '16px', 
                  fontWeight: '700', 
                  fontSize: '20px',
                  color: '#1E1E1E'
                }}>
                  Export as
                </div>
                <div style={{ display: 'flex', gap: '24px' }}>
                  {/* Mail options */}
                  <div style={{ flex: 1 }}>
                    <div style={{ 
                      marginBottom: '8px', 
                      fontWeight: '600', 
                      fontSize: '14px',
                      color: 'black',
                      lineHeight: '16px'
                    }}>
                      Mail
                    </div>
                    <div style={{ 
                      display: 'flex', 
                      flexDirection: 'column', 
                      gap: '12px',
                    }}>
                      {mailOptions.map((item, index) => (
                        <div key={`mail-${item.name}`}>
                          <StyledCheckbox
      onChange={() => handleExportMethodSelect('mail', item.name)}
      checked={selectedExportMethod === 'mail' && selectedExportType.includes(item.name)}
      disabled={
        // Disable if:
        // 1. We already have 2 options selected and this one isn't selected
        selectedExportType.length >= 2 && !selectedExportType.includes(item.name) ||
        // 2. This is a non-CV option and CV is already selected with another non-CV option
        (item.name !== 'cv_zip' && 
         selectedExportType.includes('cv_zip') && 
         selectedExportType.some(t => t !== 'cv_zip'))
      }
    >
      {item.key}
    </StyledCheckbox>
                        </div>
                      ))}
                    </div>
                  </div>
                  
                  {/* Download options */}
                  <div style={{ flex: 1 }}>
                    <div style={{ 
                      marginBottom: '8px', 
                      fontWeight: '600', 
                      fontSize: '14px',
                      color: 'black',
                      lineHeight: '16px'
                    }}>
                      Download
                    </div>
                    <div style={{ 
                      display: 'flex', 
                      flexDirection: 'column', 
                      gap: '12px',
                      marginLeft: '4px' // Add small left margin for better alignment
                    }}>
                      {downloadOptions.map((item, index) => (
                        <div key={`download-${item.name}`}>
                          <StyledCheckbox
                           onChange={() => handleExportMethodSelect('download', item.name)}
      checked={selectedExportMethod === 'download' && selectedExportType.includes(item.name)}
                          >
                            {item.key}
                          </StyledCheckbox>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                
                {hasEmailAndDownload && 
                 (selectedExportType.includes('xlsx') || 
                  selectedExportType.includes('googlesheet') || 
                  selectedExportType.includes('csv')) && 
                 targetKeys.length === 0 && (
                  <div style={{
                    marginTop: '16px',
                    color: '#ff4d4f',
                    fontSize: '14px',
                    fontWeight: '500'
                  }}>
                    Select at least one attribute to continue
                  </div>
                )}
              </div>
            )}
          </div>
          <ButtonContainer>
            <CancelButtonContainer>
              <Button
                type="default"
                onClick={() => handleClose(false)}
                style={{ marginRight: 8, backgroundColor: 'white' }}
              >
                {open ? 'Cancel' : 'Ok'}
              </Button>
            </CancelButtonContainer>

            <ExportButtonContainer>
              {!hasEmailAndDownload ? (
                <>
                  {getformat.map(item => (
                    <StyledCheckbox
                      onChange={() => handleExportType(item.name)}
                      checked={exportType === item.name}
                      key={item.name}
                    >
                      {item.key}
                    </StyledCheckbox>
                  ))}
                  <Button
                    type="primary"
                    onClick={handleExportClick}
                    disabled={!exportType || !targetKeys?.length}
                  >
                    Export
                  </Button>
                </>
              ) : (
                <Button
                  type="primary"
                  onClick={handleExportClick}
                  disabled={
                    !selectedExportType?.length || 
                    (!targetKeys?.length && 
                      (selectedExportType.includes('xlsx') || 
                       selectedExportType.includes('googlesheet') || 
                       selectedExportType.includes('csv')))
                  }
                >
                  Export
                </Button>
              )}
            </ExportButtonContainer>
          </ButtonContainer>
        </>
      </Spin>
    </StyledModal>
  )
}

export default ExportTransfer
